import React from 'react';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const DotGrid = ({ maxWidth = '160px', color = '#ee5f57', ...props }) => (
  <Box maxWidth={maxWidth} width='fit-content' {...props}>
    <motion.div
      initial={{
        opacity: 0,
        scale: 0.9,
        y: -100 // Start from above (negative y value)
      }}
      animate={{
        opacity: 1,
        scale: 1,
        y: 0 // End at the natural position
      }}
      transition={{
        type: 'spring',
        stiffness: 180, // Lower stiffness for more bounce
        damping: 20, // Lower damping for more pronounced bounce
        mass: 2.2, // Slightly more mass for better bounce physics
        duration: 0.6, // Longer duration for the full bounce effect
        delay: 0.9
      }}
    >
      <svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg' width='100%'>
        <circle cx='100' cy='100' r='90' fill={color} stroke={color} strokeWidth={0} />
      </svg>
    </motion.div>
  </Box>
);

export default DotGrid;
